import { useRouteError } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { useScopedTranslate } from '@locale/translate';

import { ActionText } from './action-text';
import { ErrorScreen } from './error-screen';
import { Text } from './text';

export function RouteErrorBoundary() {
  const error = useRouteError();
  const { styledTranslate, t } = useScopedTranslate(locale);
  Sentry.captureException(error);
  return (
    <ErrorScreen
      code={500}
      heading={t('heading')}
      flipped
      message={
        <Text
          text={styledTranslate('routeError', {
            statusPage: (
              <ActionText.ExternalLink
                href="https://50skills.statuspage.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('statusPage')}
              </ActionText.ExternalLink>
            ),
          })}
        />
      }
    />
  );
}

const locale = {
  en: {
    heading: 'Unexpected Error',
    routeError:
      'For some reason, 50skills was unable to load. Please check out our {statusPage} to check if the problem is on our end.',
    statusPage: 'status page',
  },
};
